import React from 'react';
import storeManager from '../../store/StoreManager';
import mouseUtils from '../../components/utils/MouseUtils';
import saveManager from '../utils/SaveManager';
import videoUtils from '../utils/VideoUtils';
import audioUtils from '../utils/AudioUtils';
import configuration from '../../constants/Configuration';
import properties from '../../constants/Properties';
import { setSlideSound, setSlideSoundEffect, changeSlideDuration } from '../../actions/CurrentSlideActions';
import textSizeUtils from '../utils/TextSizeUtils';
import { VolumeSlider } from '../menus/VolumeSlider';
import hoverManager from '../utils/HoverManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import locales from "../../locales/LocalesManager";
import platformDetection from "../utils/PlatformDetection";

export const SoundElement = React.createClass({
    getInitialState() {
        return {
            isCloseOver: false,
            isVolumeOver: false,
            openVolumeSlider: false
        };
    },
    componentDidMount() {
        // document.addEventListener('click', this.onCloseVolumeSlider);
        // document.addEventListener('touchend', this.onCloseVolumeSlider);
    },
    componentWillUnmount() {
        document.removeEventListener('click', this.onCloseVolumeSlider);
        document.removeEventListener('touchend', this.onCloseVolumeSlider);
    },
    onCloseMouseIn () {
        hoverManager.show(this.refs.deleteSound, 'deleteSound');

        this.setState({
            isCloseOver: true
        });
    },
    onCloseMouseOut () {
        hoverManager.hide();

        this.setState({
            isCloseOver: false
        });
    },
    onVolumeMouseIn () {
        hoverManager.show(this.refs.volumeSound, 'volumeSound');

        this.setState({
            isVolumeOver: true
        });
    },
    onVolumeMouseOut () {
        hoverManager.hide();

        this.setState({
            isVolumeOver: false
        });
    },
    onOpenVolumeSlider (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.setState({
            openVolumeSlider: true
        });
    },
    onCloseVolumeSlider (e) {
        if (textSizeUtils.isTextEditMode())
            return;

        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (!platformDetection.isIOS()) {
            if (!document.getElementById('htmlColorPicker'))
                e.preventDefault();
        }

        const target = e.target;

        var volume = 'volume1';

        if (this.props.isSoundEffect)
            volume = 'volume2';

        if (target.id == volume)
            return;

        if (target.id && target.id.indexOf('volumeIcon') != -1) {
            this.setState({
                openVolumeSlider: false
            });

            return;
        }

        if (target.id.indexOf('volumeSlider') != -1 || (target.parentElement && target.parentElement.id.indexOf('volumeSlider') != -1) || (target.parentElement && target.parentElement.parentElement && target.parentElement.parentElement.id.indexOf('volumeSlider') != -1))
            return;

        this.setState({
            openVolumeSlider: false
        });
    },
    isSoundVisible () {
        var audioSource = this.props.audioSource;

        if (audioSource)
            return true;
        else
            return false;
    },
    onRemoveSound (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        var duration;

        if (!videoUtils.isVideoBackground()) {
            if (this.props.isSoundEffect) {
                if (!audioUtils.hasSlideSound())
                    this.props.dispatch(changeSlideDuration(configuration.SLIDE_DURATION));
                else {
                    // set slide sound duration
                    duration = audioUtils.slideSoundDuration();

                    if (duration > 0)
                        this.props.dispatch(changeSlideDuration(duration));
                }
            }

            if (!this.props.isSoundEffect) {
                if (!audioUtils.hasSlideSoundEffect())
                    this.props.dispatch(changeSlideDuration(configuration.SLIDE_DURATION));
                else {
                    // set slide effect duration
                    duration = audioUtils.slideSoundEffectDuration();

                    if (duration > 0)
                        this.props.dispatch(changeSlideDuration(duration));
                }
            }
        }

        saveManager.isContentChanged(true);

        var emptySound = {};
        emptySound.href = '';
        emptySound.contentItemId = -1;
        emptySound.title = '';

        if (this.props.isSoundEffect)
            this.props.dispatch(setSlideSoundEffect(emptySound));
        else
            this.props.dispatch(setSlideSound(emptySound));

        audioEditorUtils.addActionToHistory();

        if (this.props.updateViewProperties)
            this.props.updateViewProperties();
    },
    getSoundIcon() {
        const state = storeManager.getState();
        var soundVolume;

        if (this.props.isSoundEffect)
            soundVolume = state.currentSlide.model.soundEffectVolume;
        else
            soundVolume = state.currentSlide.model.soundVolume;

        if (!soundVolume)
            soundVolume = 0.5;

        var volumeIcon = 'fa fa-volume-down';

        if (soundVolume == 0)
            volumeIcon = 'fa fa-volume-off';
        else if (soundVolume <= 0.5)
            volumeIcon = 'fa fa-volume-down';
        else if (soundVolume > 0.5)
            volumeIcon = 'fa fa-volume-up';

        return volumeIcon;
    },
    render() {
        const width = configuration.CANVAS_WIDTH * this.props.scaleProperties.scale;
        const recordMiddleGap = 8;
        const recordButtonSize = properties.RECORDING_BUTTON_HEIGHT;
        var soundVisibility = 'none';
        var titleVisibility = 'none';
        var soundTitle = textSizeUtils.correctRecordingTitle(this.props.soundTitle);
        var titleWidth = textSizeUtils.getSpanWidth(12, soundTitle);
        var soundWidth = properties.RECORDING_SOUND_BUTTON_WIDTH + titleWidth;
        var recordButtonLeftPos = width / 2 - recordButtonSize - recordMiddleGap / 2;
        const borderSize = 1;
        var iconColor;
        var leftPos = recordButtonLeftPos - recordMiddleGap - soundWidth;

        if (this.props.isSoundEffect)
            leftPos = recordButtonLeftPos + 2 * recordMiddleGap + 2 * recordButtonSize;

        if (this.isSoundVisible())
            soundVisibility = 'block';

        if (soundTitle.length > 0) {
            titleVisibility = 'block';
        }

        const soundStyle = {
            width: soundWidth,
            height: properties.RECORDING_BUTTON_HEIGHT + 2,
            background: properties.ADD_MUSIC_BUTTON_BACKGROUND,
            position: 'absolute',
            left: leftPos,
            top: (properties.RECORDING_MENU_HEIGHT - properties.RECORDING_BUTTON_HEIGHT) / 2 - borderSize,
            borderRadius: 20,
            display: soundVisibility
        };

        const soundTitleStyle = {
            fontSize: 12,
            height: 20,
            width: titleWidth,
            whiteSpace: 'nowrap',
            cursor: 'default',
            position: 'absolute',
            top: 9,
            left: 32,
            color: 'black',
            textAlign: 'center',
            display: titleVisibility
        };

        if (this.state.isCloseOver == true)
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        else
            iconColor = 'black';

        const closeIconStyle = {
            position: 'absolute',
            top: 7,
            left: soundStyle.width - 23,
            color: iconColor
        };

        var closeAreaStyle = {
            position: 'absolute',
            width: 32,
            height: 30,
            left: soundStyle.width - 32,
            top: 0,
            background: 'none',
            borderStyle: 'none'
        };

        var animationType = 'slideSoundAnimation';
        var type = 'slideSound';
        var volume = 'volume1'

        if (this.props.isSoundEffect) {
            animationType = 'slideSoundEffectAnimation';
            type = 'slideSoundEffect';
            volume = 'volume2';
        }

        if (this.state.isVolumeOver == true)
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        else
            iconColor = 'black';

        var volumeIconStyle = {
            position: 'absolute',
            top: 7,
            left: 11,
            color: iconColor
        };

        var volumeAreaStyle = {
            position: 'absolute',
            width: 24,
            height: 30,
            left: 2,
            top: 0,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            background: 'none',
            borderStyle: 'none'
        };

        var iconType = this.getSoundIcon();

        return (
            <div id={type} style={soundStyle}>
                <i style={volumeIconStyle} className={iconType + ' ' + animationType}></i>
                <button aria-label={locales.getCaption('volumeSound', 'hover')} ref='volumeSound' id={volume} style={volumeAreaStyle} onMouseOver={this.onVolumeMouseIn} onMouseOut={this.onVolumeMouseOut} onClick={this.onOpenVolumeSlider} onTouchEnd={this.onOpenVolumeSlider}/>
                <span className={animationType} style={soundTitleStyle}>{soundTitle}</span>
                <i style={closeIconStyle} className={'fa fa-close ' + animationType}></i>
                <button aria-label={locales.getCaption('deleteSound', 'hover')} ref='deleteSound' style={closeAreaStyle} onMouseOver={this.onCloseMouseIn} onMouseOut={this.onCloseMouseOut} onClick={this.onRemoveSound} onTouchEnd={this.onRemoveSound}/>
                <VolumeSlider dispatch={this.props.dispatch} visible={this.state.openVolumeSlider} type={type}/>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/SoundElement.js
 **/